import { types } from 'mobx-state-tree';
import { ALARMS_TYPES } from 'config/alarmsType';

export const NotificationPreference = types.model({
  id: types.integer,
  alarm_type: types.enumeration('alarm_type', Object.values(ALARMS_TYPES)),
  archived: types.boolean,
  emailing: types.boolean,
  establishment_id: types.integer,
  user_id: types.integer,
});
